
<div class="stu-visibility-page" *ngIf="!submitting; else loadingTpl">
	<div class="copo-toolbar">
		<div class="copo-centered-block">
			<div class="login-internal-select" translate>login.internal-select-organization</div>
			<mat-form-field appearance="outline" class="copo-no-error-message search-full-width" [floatLabel]="'never'">
				<input matInput spellcheck="false" autocomplete="off" [formControl]="searchControl" [placeholder]="'login.search-organization' | translate">
				<button type="button" *ngIf="searchControl.value" matSuffix mat-icon-button (click)="searchControl.reset('')" tabindex="-1">
					<mat-icon svgIcon="md:close"></mat-icon>
				</button>
			</mat-form-field>
		</div>
	</div>

	<div class="stu-visibility-content" cdkScrollable copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller" (moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
		<ng-container *ngIf="!willLoad">
			<div class="last-used-container" *ngIf="getLatests(scroller.list, true) as latests">
				<div class="last-used-label" translate>login.last-selections</div>
				<button
						*ngFor="let visi of latests; let i = index"
						type="button"
						class="visibility-select-button"
						[class.visibility-select-button-selected]="selectedVisi !== undefined && visi.userId === selectedVisi.userId && visi.visibilityGroupId === selectedVisi.visibilityGroupId"
						mat-ripple
						(click)="selectedVisi = visi"
						>
					<div class="visibility-select-button-label">{{ visi.visibilityGroupName }}</div>
				</button>
			</div>
			<ng-container *ngIf="getLatests(scroller.list, false) as notLatests">
				<div class="last-used-label" translate>login.organizations-list</div>
				<button
						*ngFor="let visi of notLatests; let i = index"
						type="button"
						class="visibility-select-button"
						[class.visibility-select-button-selected]="selectedVisi !== undefined && visi.userId === selectedVisi.userId && visi.visibilityGroupId === selectedVisi.visibilityGroupId"
						mat-ripple
						(click)="selectedVisi = visi"
						>
					<div class="visibility-select-button-label">{{ visi.visibilityGroupName }}</div>
				</button>
			</ng-container>
		</ng-container>
		<div *ngIf="!(willLoad || scroller.loading) && scroller.list.length === 0" translate>login.no-result</div>
		<copo-loading-spinner *ngIf="willLoad || scroller.loading"></copo-loading-spinner>
	</div>

	<div class="login-button-group">
		<div class="copo-centered-block">
			<button type="submit" [disabled]="selectedVisi === undefined" mat-raised-button color="accent" class="stu-visibility-field" (click)="simulate()">
				<span *ngIf="!selectedVisi" translate>login.select-organization-above</span>
				<span *ngIf="selectedVisi"><span translate>login.delegate-myself-to</span>&ngsp;{{ selectedVisi.visibilityGroupName }}</span>
			</button>
			<div class="copo-visi-horizontal-buttons stu-visibility-field">
				<button type="button" mat-button [routerLink]="['/select-visibility']" [queryParamsHandling]="'preserve'" [replaceUrl]="true" *ngIf="hasSimulation">
					<span translate>login.use-simulation</span>
				</button>
				<button type="button" mat-button (click)="logout()">
					<span translate>login.logout</span>
				</button>
			</div>
		</div>
	</div>
</div>
<ng-template #loadingTpl>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>